import { render, staticRenderFns } from "./commonHelp.vue?vue&type=template&id=6a48be9e"
import script from "./commonHelp.vue?vue&type=script&lang=js"
export * from "./commonHelp.vue?vue&type=script&lang=js"
import style0 from "./commonHelp.vue?vue&type=style&index=0&id=6a48be9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports